import React from "react";
import style from "./ObjectiveSection.module.css";
import { useEffect, useRef, useState } from "react";

import Cards from "./Cards";

const ObjectiveSection = () => {
  const [inView, setInView] = useState(false);
  const lineRefLeft = useRef(null);
  const lineRefRight = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true); // Trigger animations when the element is in view
          } else {
            setInView(false); // Optionally reset if the element goes out of view
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the element is in view
    );

    if (lineRefLeft.current) {
      observer.observe(lineRefLeft.current);
    }

    return () => {
      if (lineRefLeft.current) {
        observer.unobserve(lineRefLeft.current);
      }
    };
  }, []);

  return (
    <div
      className={style.container}
      style={{ background: `url("./assets/OBJ.jpg")` }}
    >
      <div style={{ width: "80%", margin: "auto" }}>
        <div className={style.animecontainer}>
          {/* Line from Left to Right */}
          <div
            className={`${style.animation} ${
              inView ? style.lineLeftToRight : ""
            }`}
            ref={lineRefLeft}
          ></div>

          {/* Text ("Our Objectives") */}
          <div
            className={`${style.text} ${inView ? style.showText : ""}`}
            ref={textRef}
          >
            Our Beliefs
          </div>

          {/* Line from Right to Left */}
          <div
            className={`${style.animation} ${
              inView ? style.lineRightToLeft : ""
            }`}
            ref={lineRefRight}
          ></div>
        </div>
        <div></div>
      </div>
      <Cards />
    </div>
  );
};

export default ObjectiveSection;
